import React, { useState, useEffect } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import moment from "moment";
import $ from "jquery";
import "daterangepicker/daterangepicker.css";
import "daterangepicker";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const DatewiseReport = () => {
  const [startDate, setStartDate] = useState(moment("2020-01-01").format("YYYY-MM-DD")); // Earliest date
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [district, setDistrict] = useState("all");
  const [type, setType] = useState("all");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = "Date Wise Group - Calendar Services";
    // Set the initial start date to a very early date to include all records
    const earliestDate = moment("2020-01-01"); // Start from the year 2000
    const today = moment();
  
    setStartDate(earliestDate.format("YYYY-MM-DD"));
    setEndDate(today.format("YYYY-MM-DD"));

  // Initialize the date range picker
  $("#kt_daterangepicker_4").daterangepicker(
   {
        startDate: earliestDate,
        endDate: today,
        ranges: {
          "From the Beginning": [earliestDate, today], // Custom option to select all records
          Today: [today, today],
          Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
          "Last 7 Days": [moment().subtract(6, "days"), today],
          "Last 30 Days": [moment().subtract(29, "days"), today],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Month": [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")],
        },
    },
      (start, end) => {
        setStartDate(start.format("YYYY-MM-DD"));
        setEndDate(end.format("YYYY-MM-DD"));
        $("#kt_daterangepicker_4").html(`${start.format("MMMM D, YYYY")} - ${end.format("MMMM D, YYYY")}`);
      }
    );

    // Set initial display value
    $("#kt_daterangepicker_4").html(
      `${moment("2020-01-01").format("MMMM D, YYYY")} - ${moment().format("MMMM D, YYYY")}`
    );
  }, []);

  useEffect(() => {
    fetchData();
  }, [startDate, endDate, district, type]);

  const fetchData = async () => {
    setLoading(true);
    try {
      // const response = await axios.post("http://localhost:3036/datewise_report", {

        const response = await axios.post(`${API_BASE_URL}/datewise_report`, {

        
        startDate,
        endDate,
        district,
        type,
      });
      setData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { name: "SlNo", selector: (row) => row.slNo, sortable: true },
    { name: "Date", selector: (row) => row.date, sortable: true },
    { name: "Plan Count", selector: (row) => row.planCount, sortable: true },
    { name: "View Count", selector: (row) => row.viewCount, sortable: true },
    { name: "Call Count", selector: (row) => row.callCount, sortable: true },
  ];

  return (
    <div className="max-w-6xl mx-auto mt-8 bg-white p-6">
      <h2 className="text-2xl font-bold mb-6 text-center text-blue-700">Date Wise Plan, Call & View Count</h2>

      <div className="filters mb-4 flex flex-wrap gap-9">
        <div className="filter-item">
          <label className="block font-medium mb-1">Date Range:</label>


          
         <div className="mb-3">
                      <div className="text-center mb-6 flex items-center space-x-2 justify-center">
                       <div
                                                id="kt_daterangepicker_4"
                                                className="bg-white border px-4 py-2 inline-block rounded cursor-pointer"
                                              >
                                                {`${moment("2020-01-01").format("MMMM D, YYYY")} - ${moment().format("MMMM D, YYYY")}`}
                                              </div>
          
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5 text-gray-500"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M8 7V3m8 4V3m-6 4h6m4 0a2 2 0 012 2v10a2 2 0 01-2 2H6a2 2 0 01-2-2V9a2 2 0 012-2h12z"
                          />
                        </svg>
                      </div>
                    </div>
          
        </div>

        {/* Type Filter */}
        <div className="filter-item">
          <label className="block font-medium mb-1">Type:</label>
          <select
            value={type}
            onChange={(e) => setType(e.target.value)}
            className="bg-white border px-4 py-2 inline-block rounded cursor-pointer"
          >
            <option value="all">வகையை தேர்வு செய்க</option>
            <option value="வாஸ்து நிபுணர்">வாஸ்து நிபுணர்</option>
            <option value="மற்ற ஆன்மிக சேவைகள்">மற்ற ஆன்மிக சேவைகள்</option>
            <option value="ஜோதிடர்">ஜோதிடர்</option>
            <option value="ஐயர்">ஐயர்</option>
            <option value="எண்கணிதம்">எண்கணிதம்</option>
            <option value="அலங்காரம் செய்பவர்others">அலங்காரம் செய்பவர்others</option>
            <option value="சிற்பி / ஸ்தபதி- others">சிற்பி / ஸ்தபதி- others</option>
            <option value="others">others</option>
            <option value="ஆன்மீக சொற்பொழிவாளர்- others">ஆன்மீக சொற்பொழிவாளர்- others</option>
            <option value="விபூதி தயாரிப்பவர்- others">விபூதி தயாரிப்பவர்- others</option>
            <option value="சிர்பி-others">சிர்பி-others</option>
            <option value="திருவிழா அலங்காரம் செய்பவர்- others">திருவிழா அலங்காரம் செய்பவர்- others</option>
          </select>
        </div>
      </div>

      {/* Data Table */}
      {loading ? (
        <p className="text-center text-gray-500">Loading...</p>
      ) : (
        <DataTable
          columns={columns}
          data={data}
          pagination
          className="mt-4"
          highlightOnHover
          striped
        />
      )}
    </div>
  );
};

export default DatewiseReport;
